const mutateListings = (listings, site) => {
  return listings.reduce((acc, item) => {
    const {
      arrivalDate,
      continueSearchSummary,
      seeMoreLikeThis,
      departureDate,
      searchTerm,
      searchTime,
      propertiesSummary,
      lbsUuid
    } = item;

    const properties = propertiesSummary && propertiesSummary.properties.map(({ hit, presentation, addedTime }) => ({
      ...hit,
      ...presentation,
      addedTime
    }));

    // NOTE: this happens when a property has been deleted.
    // In this case, we don't want the search card to appear.
    if (!properties) {
      return acc;
    }

    const search = {
      arrivalDate,
      continueSearchSummary: {
        ...continueSearchSummary,
        href: (site !== 'vrbo' && seeMoreLikeThis && seeMoreLikeThis.href) || (continueSearchSummary && continueSearchSummary.href)
      },
      departureDate,
      searchTerm,
      searchTime,
      lbsUuid,
      isSearch: true
    };

    return [
      ...acc,
      search,
      ...properties
    ];
  }, []);
};

const mutate = (data, site) => {
  const {
    summaries,
    messagesSummary,
    footerSummary,
    totalResults
  } = data;

  return {
    title: messagesSummary && messagesSummary.scratchpadActivity,
    data: totalResults > 0 && mutateListings(summaries, site) || [],
    viewInScratchpad: footerSummary && footerSummary.headline
  };
};

export default mutate;



// WEBPACK FOOTER //
// ./src/universal/api/mutations/scratchpad.js